/** Internal messaging, and the copy on its animated app screen. */
import messagesMini from '@/assets/images/screens/messages-mini.webp'

import { ACTIONS } from '../site'

export const MESSAGING = {
  eyebrow: 'Internal messaging',
  title: 'Talk to your team',
  // Follows the title and fills with blue as the section scrolls in.
  mark: 'without leaving the app',
  text: "Direct messages, group chats and a chat for every meeting. See who has read a message, reply to it, and share files, with everyone's role shown next to their name.",
  cta: ACTIONS.demo,
  // The app screen beside the text, with the cards floating over it.
  art: {
    screen: messagesMini,
    photo: { title: 'Nile room setup', meta: 'Shared by Noura · HR' },
    seen: {
      avatars: [
        { initials: 'OF', tone: 'teal' },
        { initials: 'NA', tone: 'violet' },
        { initials: 'SH', tone: 'orange' },
      ],
      label: 'Seen by 4',
    },
  },
}
